import { RouteRecordRaw } from 'vue-router';


export const hrAgRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'hr_ag-layout',
        component: () => import('@/layouts/HrAgLayout.vue'),
        meta: {
            requiresAuth: true,
            tenant_type: ['hr_ag'],
        },
        children: [
            {
                path: '',
                name: 'default-hr-ag',
                redirect: '/dashboard',
            },
            {
                path: 'dashboard',
                name: 'dashboard',
                component: () => import('@/pages/hr_ag/dashboard/Dashboard.vue'),
                meta: {
                    title: 'dashboard',
                },
            },
            {
                path: 'drivers',
                name: 'drivers',
                component: () => import('@/pages/drivers/DriversPage.vue'),
                meta: {
                    title: 'Drivers',
                },
            },
            {
                path: 'drivers/calendar-overview',
                name: 'calendar-overview',
                component: () => import('@/pages/drivers/components/CalendarOverview.vue'),
                meta: {
                    title: 'Holidays',
                },
            },
            {
                path: 'driver/:id',
                name: 'driver',
                component: () => import('@/pages/drivers/DriverDetailPage.vue'),
                meta: {
                    title: 'Driver Detail',
                },
            },
            {
                path: 'documents',
                name: 'Documents',
                component: () => import('@/pages/documents/DocumentsPage.vue'),
                meta: {
                    title: 'Documents',
                },
            },
            {
                path: 'settings',
                name: 'settings',
                component: () => import('@/pages/settings/SettingsPage.vue'),
                meta: {
                    title: 'Settings',
                    roles: ['admin', 'manger', 'planner'],
                },
            },
            {
                path: 'chat',
                component: () => import('@/pages/chat/ChatPage.vue'),
            },
            {
                path: 'chat-groups',
                component: () => import('@/pages/chat-groups/ChatGroupsView.vue'),
            },
            {
                path: 'timesheet',
                name: 'timesheet',
                component: () => import('@/pages/timesheet/TimesheetPage.vue'),
                meta: {
                    title: 'Timesheet',
                },
            },
            {
                path: 'audit-logs',
                name: 'audit-logs-hr-ag',
                component: () => import('@/pages/audit-logs/AuditLogsPage.vue'),
                meta: {
                    title: 'Audit Logs',
                },
            },

        ],
    },
];
